import { createCeederoApi } from "@/api/ceedero-api";

/**
 * Where the API is, from the browser's point of view.
 *
 * **Empty in development on purpose.** An empty origin makes every request
 * same-origin, so it goes to Vite and is proxied to the API from there. Naming
 * the API directly would make it cross-origin from `localhost`, which
 * production refuses by design: exactly one origin may send credentialed
 * requests, and it is the deployed application rather than anybody's laptop.
 * The symptom is a request that fails before it is even refused — a CORS block
 * the transport can only report as "could not be reached".
 *
 * In production it is the API itself, which is also the one origin the
 * Content-Security-Policy allows connecting to; a value disagreeing with that
 * would be blocked by the browser before the API ever saw it.
 */
export const CEEDERO_API_ORIGIN = import.meta.env.DEV ? "" : "https://api.ceedero.com";

export const ceederoApi = createCeederoApi({ origin: CEEDERO_API_ORIGIN });
